export default "__VITE_ASSET__8ce542c3__"